import React, { useEffect, useState } from "react";
import { Button, DatePicker, Modal, Select, Space, Input, Form } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Option } from "antd/es/mentions";
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

const CommentFilter = ({ form, isModalOpen, handleCancel, setFilterForm, filterForm, handleFilter }) => {
  return (
     <>
          <Modal
            title="Filters"
            open={isModalOpen}
            onOk={handleFilter}
            okText={"Filter Data"}
            onCancel={handleCancel}
          >
            <Form form={form} layout="vertical" >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
               
    
                <Form.Item
                  name="salonName"
                  className="subscription-plan"
                  rules={[
                    { required: true, message: "Please enter the salon name!" },
                  ]}
                >
                  <Input value={filterForm?.salonName} onChange={(e) => setFilterForm({ ...filterForm, name: e.target.value })} size="large" placeholder="filter by salon name" />
                </Form.Item>
    
    
    
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                <Form.Item
                  name="customerName"
                  className="subscription-plan"
                  rules={[
                    { required: true, message: "Please enter the customer name" },
                  ]}
                >
                  <Input value={filterForm?.customerName} onChange={(e) => setFilterForm({ ...filterForm, name: e.target.value })} size="large" placeholder="filter by customer name" />
                </Form.Item>
    
                <Form.Item
                  name="status"
                  className="subscription-plan"
                >
                  <Select
                    value={filterForm?.status}
                    onChange={(value) => setFilterForm({ ...filterForm, status: value })}
                    placeholder="filter by status"
                    style={{
                      marginTop: "0.5rem",
                      width: "99%",
                    }}
                    options={[
                      {
                        value: "0",
                        label: "InActive",
                      },
                      {
                        value: "1",
                        label: "Active",
                      },
                    ]}
                  />
                </Form.Item>
    
    
    
              </div>
          
           
              <div>
                <Space direction="vertical" size={12} style={{ marginBottom: "20px" }}>
               
                </Space>
              </div>
            </Form>
          </Modal>
        </>
  )
}

export default CommentFilter